/* ============================================================
   STENS — Products page filter logic
   Filters product cards by selected vehicle compatibility
   ============================================================ */
(function() {
  'use strict';

  // Compatibility map — which products fit which vehicles
  // In production this would come from a fitments database.
  // Here we use simple rules: every product fits a given subset of makes.
  const COMPAT = {
    // Street series — fits broad range
    'ST-2810': ['BMW', 'Audi', 'Volkswagen', 'Mercedes-Benz'],
    'ST-2825': ['BMW', 'Audi', 'Volkswagen', 'Mercedes-Benz', 'Honda', 'Mazda'],
    'ST-2835': ['BMW', 'Audi', 'Volkswagen', 'Mercedes-Benz', 'Volvo'],

    // Sport series — performance-focused
    'SP-3540': ['BMW', 'Audi', 'Volkswagen', 'Honda', 'Subaru', 'Toyota'],
    'SP-3535': ['BMW', 'Audi', 'Volkswagen', 'Mercedes-Benz', 'Mazda'],
    'SP-3550': ['BMW', 'Audi', 'Porsche', 'Mercedes-Benz', 'Honda'],

    // Race series — limited fitments
    'RC-4520': ['BMW', 'Audi', 'Volkswagen', 'Subaru', 'Toyota'],
    'RC-4540': ['BMW', 'Audi', 'Porsche', 'Subaru'],
    'RC-4560': ['BMW', 'Porsche', 'Honda', 'Subaru', 'Toyota'],
  };

  function isProductCompatible(productId, vehicleMake) {
    const makes = COMPAT[productId];
    if (!makes) return true; // Unknown product — assume compatible
    return makes.includes(vehicleMake);
  }

  function getVehicleFromStorage() {
    try {
      const raw = sessionStorage.getItem('stens_vehicle');
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return null;
  }

  function getProductIdFromCard(card) {
    const href = card.getAttribute('href') || '';
    const match = href.match(/[?&]id=([^&]+)/);
    return match ? match[1] : null;
  }

  function applyFilter() {
    const vehicle = getVehicleFromStorage();
    const banner = document.getElementById('compatBanner');
    const sections = document.querySelectorAll('[data-series-section]');

    if (!vehicle || !vehicle.make) {
      // No filter — clear everything
      sections.forEach(s => {
        s.classList.remove('has-filter');
        s.querySelectorAll('.product-card').forEach(c => {
          c.classList.remove('is-incompatible', 'is-compatible');
        });
      });
      if (banner) banner.style.display = 'none';
      return;
    }

    // Apply filter
    let totalCompat = 0;
    sections.forEach(s => {
      s.classList.add('has-filter');
      s.querySelectorAll('.product-card').forEach(card => {
        const pid = getProductIdFromCard(card);
        const compat = pid ? isProductCompatible(pid, vehicle.make) : false;
        card.classList.toggle('is-compatible', compat);
        card.classList.toggle('is-incompatible', !compat);
        if (compat) totalCompat++;
      });
    });

    // Show banner
    if (banner) {
      banner.style.display = '';
      const subEl = banner.querySelector('.compat-banner-sub');
      const countEl = banner.querySelector('.compat-banner-count strong');
      const titleEl = banner.querySelector('.compat-banner-title');
      if (subEl) subEl.textContent = `${vehicle.make} · ${vehicle.model} · ${vehicle.year} · ${vehicle.engine}`;
      if (countEl) countEl.textContent = totalCompat;
      if (titleEl) titleEl.innerHTML = `Showing parts for <strong>${vehicle.make} ${vehicle.model}</strong>`;
    }
  }

  function clearFilter() {
    try { sessionStorage.removeItem('stens_vehicle'); } catch (e) {}
    document.dispatchEvent(new CustomEvent('stens:vehicle-cleared'));
    applyFilter();
  }

  function init() {
    // Initial filter (in case vehicle saved from previous session)
    applyFilter();

    // Banner clear button
    const clearBtn = document.getElementById('compatBannerClear');
    if (clearBtn) {
      clearBtn.addEventListener('click', clearFilter);
    }

    // Listen for vehicle events
    document.addEventListener('stens:vehicle-selected', applyFilter);
    document.addEventListener('stens:vehicle-cleared', () => {
      const banner = document.getElementById('compatBanner');
      if (banner) banner.style.display = 'none';
      document.querySelectorAll('[data-series-section]').forEach(s => {
        s.classList.remove('has-filter');
        s.querySelectorAll('.product-card').forEach(c => {
          c.classList.remove('is-incompatible', 'is-compatible');
        });
      });
    });

    // Expose for vfinder to call after submit
    window.STENS_filterProducts = applyFilter;
    window.STENS_isProductCompatible = isProductCompatible;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
